import Vue from 'vue'
import VueI18n from 'vue-i18n'

const l =  require("builder/src/locale/index.js").default;
const lambda_mn = require("builder/src/locale/mn_MN.js").default;
const lambda_en = require("builder/src/locale/en_US.js").default;
const app_mn =  require("locale/mn_mn.json");
const app_en = require("locale/en_us.json");
const app_ch = require("locale/ch_zh.json");


Vue.use(VueI18n)

const messages = {
    'mn_MN': {
        ...lambda_mn,
        ...app_mn
    },
    'en_US': {
        ...lambda_en,
        ...app_en
    },
    'ch_ZH': {
        ...app_ch
    }
}

export const i18n = new VueI18n({
    locale: 'mn_MN', // set locale
    fallbackLocale: 'mn_MN',
    messages
})

const loadedLanguages = ['mn_MN','en_US', 'ch_ZH']

export const setI18nLanguage = (lang) => {
    i18n.locale = lang
    return lang
}

export const loadLanguageAsync = (lang) => {
    localStorage.setItem("lang", lang);
    // l.loadLanguageAsync(lang);

    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // if (window.lambda && window.lambda.static_words && window.lambda.static_words[lang]) {
    //     i18n.setLocaleMessage(lang, {auth: window.lambda.static_words[lang]});
    //     loadedLanguages.push(lang)
    //     return setI18nLanguage(lang)
    // } else {
    //     // return import(`./${lang}`).then(
    //     //     messages => {
    //     //         i18n.setLocaleMessage(lang, messages.default)
    //     //         loadedLanguages.push(lang)
    //     //         return setI18nLanguage(lang)
    //     //     }
    //     // )
    // }
}
